import { cn } from '@/lib/utils/utils';

export function TextInput({ placeholder, className, ...props }) {
    return (
        <input
            type="text"
            placeholder={placeholder}
            className={cn(
                'w-full px-6 py-4 bg-surface-hover rounded-full text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20',
                className,
            )}
            {...props}
        />
    );
}

export function EmailInput({ placeholder = 'Email*', className, ...props }) {
    return (
        <input
            type="email"
            placeholder={placeholder}
            className={cn(
                'w-full px-6 py-4 bg-surface-hover rounded-full text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20',
                className,
            )}
            {...props}
        />
    );
}
